module.exports = "/dist/fb8d6b71dbe8d9294be43082936f649e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500.woff2
// module id = 125
// module chunks = 0